import type { TConta } from '@/shared/interfaces/conta.types'
import { HttpService } from '@/shared/lib/http'

export class GetPessoaJuridicaCnpjService extends HttpService {
  async execute({ cnpj }: { cnpj: string }) {
    return this.http.get<TConta>(`api/v2/Conta/${cnpj}`)
  }
}
